'use strict';

export default function chartConfig(scope) {
  'ngInject';

  let chartConfig = {
    chart: {
      type: 'line',
      height: 400,
      events: {
        load: function () {
          // Highcharts オブジェクトへの参照をコンパクトに実現するため、arrow function を用いない
          scope.chart = this;
        }
      }
    },
    title: {
      text: 'デマンド状況'
    },
    xAxis: {
      type: 'datetime',
      labels: {
        format: "{value:%H:%M}"
      }
    },
    yAxis: {
      plotBands: [{
        color: 'rgba(68,170,213,0.1)'
      }],
      title: {
        text: 'kW',
        margin: 5,
        style: { color: '#5d5d5d' }
      }
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      floating: true,
      verticalAlign: 'top',
      reversed: true,
      x: -45
    },
    tooltip: {
      headerFormat: '<span style="font-size: 12px;">{point.key}</span><br/>',
      pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b style="font-size: 14px;">{point.y} kW</b><br/>',
      xDateFormat: '%H:%M:%S'
    },
    plotOptions: {
      line: {
        marker: {
          enabled: false
        }
      }
    },
    series: [
      {
        name: '目標電力',
        color: '#8bc34a',
        marker: {
          enabled: false,
          states: {
            hover: {
              enabled: false
            }
          }
        },
        tooltip: {
          followPointer: true,
          headerFormat: ''
        }
      },
      {
        name: '限界電力',
        color: '#e67e22',
        marker: {
          enabled: false,
          states: {
            hover: {
              enabled: false
            }
          }
        },
        tooltip: {
          followPointer: true,
          headerFormat: ''
        }
      },
      {
        name: '契約電力',
        color: '#D32F2F',
        marker: {
          enabled: false,
          states: {
            hover: {
              enabled: false
            }
          }
        },
        tooltip: {
          followPointer: true,
          headerFormat: ''
        }
      },
      {
        name: '予測値',
        color: '#00acc1',
        marker: {
          enabled: false
        },
        dashStyle: 'ShortDash',
        lineWidth: 3,
        tooltip: {
          headerFormat: ''
        }
      },
      {
        name: '前日の実績',
        color: '#3d5afe',
        marker: {
          enabled: false
        },
        turboThreshold: 0
      },
      {
        name: '実績',
        color: '#26c6da',
        marker: {
          symbol: 'circle'
        },
        lineWidth: 4,
        turboThreshold: 0
      }
    ]
  };

  return chartConfig;
}



// WEBPACK FOOTER //
// ./public/dev/app/demand/detail/demand_detail.config.js